import { render } from "./Roadmap.vue?vue&type=template&id=6ffb223a&scoped=true"
import script from "./Roadmap.vue?vue&type=script&lang=js"
export * from "./Roadmap.vue?vue&type=script&lang=js"

import "./Roadmap.vue?vue&type=style&index=0&id=6ffb223a&lang=scss&scoped=true"

import exportComponent from "/vercel/path5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ffb223a"]])

export default __exports__